import { call, put } from 'redux-saga/effects'

import { __get } from 'hfty-fetch'

import { CHECK_EULA_URL, EFFECTIVE_DATE } from '../constants'
import { acceptEula, checkEulaStatus } from '../actions'

import _size from 'lodash/size'

export default function *checkEula () {
  try {
    yield put(checkEulaStatus())
    const response = yield call(__get, {
      path: `${CHECK_EULA_URL}/?version=${EFFECTIVE_DATE}&type=hefty`,
    })

    if (response.status >= 200 && response.status < 300) {
      const json = yield call([response, response.json])
      const accepted = !!(json && _size(json))

      if (accepted) {
        yield put(acceptEula(true))
        return true
      } else {
        yield put(acceptEula(false))
        return false
      }
    }
  } catch (error) {
    return false
  }
}
